var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.4044C11.4597 13.4044 10.7661 14.0972 10.7661 15.1364C10.7661 15.8291 11.2863 16.3487 11.8065 16.5219L11.2863 18.9466H13.5403L13.0202 16.5219C13.7137 16.3487 14.0605 15.8291 14.0605 15.1364C14.2339 14.0972 13.5403 13.4044 12.5 13.4044ZM12.6734 5.95706C11.4597 5.95706 10.246 6.82303 10.246 8.03539V10.6333H14.9274V8.03539C14.754 6.82303 13.8871 5.95706 12.6734 5.95706ZM12.5 0.241638L0.362915 5.43747V10.6333C0.536302 18.2539 5.39114 25.0084 12.5 27.7796C19.6089 25.0084 24.4637 18.2539 24.6371 10.6333V5.43747L12.5 0.241638ZM19.4355 19.293C19.4355 20.3322 18.7419 21.025 17.7016 21.025H7.2984C6.25808 21.025 5.56453 20.3322 5.56453 19.293V12.3653C5.56453 11.3261 6.25808 10.6333 7.2984 10.6333H7.81856V8.03539C7.99195 5.61067 10.0726 3.70553 12.5 3.70553C14.9274 3.70553 17.0081 5.61067 17.1815 8.03539V10.6333H17.7016C18.7419 10.6333 19.4355 11.3261 19.4355 12.3653V19.293Z",
    fill: "#7BFBF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.f0af822543bb45e4db4079b22a5b78ff.svg";
export { ForwardRef as ReactComponent };